import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { withStyles } from '@material-ui/core/styles'
import { signOut } from 'redux/modules/auth'
import { selectUser, authHbUserDone } from 'redux/modules/user'
import { changeChat } from 'redux/modules/settings'
import { getHeaderTitle } from 'utils/pathMatcher'
import {
  MODAL_CLIENT_START_DAY,
  MODAL_CLIENT_END_DAY,
  MODAL_CLIENT_SELECT_USER,
  MODAL_CLIENT_ADMIN_CODE,
  MODAL_CLIENT_PRICING_MODAL,
  showModal
} from 'redux/modules/modals'
import TillForm from 'components/hiboutikForms/TillForm'
import Logo from 'assets/logo.png'
import AppBar from '@material-ui/core/AppBar'
import Avatar from '@material-ui/core/Avatar'
import Toolbar from '@material-ui/core/Toolbar'
import Switch from '@material-ui/core/Switch'
import Divider from '@material-ui/core/Divider'
import MenuItem from '@material-ui/core/MenuItem'
import Menu from '@material-ui/core/Menu'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import AuthForm from 'components/hiboutikForms/AuthForm'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import NavigationLeft from '@material-ui/icons/ChevronLeft'
import SwapCallsIcon from '@material-ui/icons/SwapCalls'
import AccountCircle from '@material-ui/icons/AccountCircle'
import VersionIcon from '@material-ui/icons/LocalOffer'
import FinishDayIcon from '@material-ui/icons/FlightLand'
import ChatIconOn from '@material-ui/icons/ChatBubble'
import ChatIconOff from '@material-ui/icons/ChatBubbleOutline'
import TillIcon from '@material-ui/icons/MoveToInbox'
import UpdatePricingIcon from '@material-ui/icons/Update'
import PricingIcon from '@material-ui/icons/WatchLater'
import AdminIcon from '@material-ui/icons/SupervisorAccount'
import amber from '@material-ui/core/colors/amber'

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  appBar: {
    backgroundColor: __DEV__ || __STAGING__ ? amber[500] : ''
    // borderTop: __DEV__ || __STAGING__ ? `3px solid ${orange[500]}` : ''
  },
  flex: {
    flex: 1
  },
  logoAvatarSmall: {
    marginRight: 20,
    border: '1px solid white',
    width: 32,
    height: 32
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
    color: theme.palette.common.white
  },
  avatar: {
    margin: 0,
    color: theme.palette.common.white,
    border: '2px solid white'
  },
  menu: {},
  menuItem: {
    minWidth: 200,
    '&:hover': {
      '& $primary, & $icon': {
        color: theme.palette.primary.main
      }
    }
  },
  primary: {},
  icon: {
    color: theme.palette.primary.main
  }
})
class HeaderContainer extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    settings: PropTypes.object.isRequired,
    transactions: PropTypes.array.isRequired,
    showModal: PropTypes.func.isRequired,
    changeChat: PropTypes.func.isRequired,
    location: PropTypes.object,
    currentUser: PropTypes.object,
    authHbUserDone: PropTypes.func.isRequired,
    currentPricing: PropTypes.object
  }
  tillRef = null
  state = {
    anchorEl: null,
    rightMenuOpen: false,
    showChat: true
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.settings) {
      if (
        nextProps.settings.currentDates !== null &&
        !nextProps.settings.currentDates.isStarted
      ) {
        this.props.showModal(MODAL_CLIENT_START_DAY)
      }
    }
  }
  shouldHaveBackButton(pathname) {
    if (pathname.includes('home')) {
      return false
    }
    if (pathname.startsWith('/') && pathname.split('/').length > 2) {
      return true
    } else if (!pathname.startsWith('/') && pathname.split('/').length > 1) {
      return true
    } else {
      return false
    }
  }
  titleFromLocation(pathname) {
    return getHeaderTitle(pathname, this.props.transactions)
  }
  handleAdminClick = e => {
    this.props.showModal(MODAL_CLIENT_ADMIN_CODE)
  }
  handleChangePricingClick = e => {
    this.props.showModal(MODAL_CLIENT_PRICING_MODAL)
  }
  handleBackButtonClick = e => {
    this.props.history.goBack()
  }
  handleTillClick = e => {
    this.tillRef.handleSubmitClick()
  }
  handleChangeUserClick = e => {
    this.props.showModal(MODAL_CLIENT_SELECT_USER)
  }
  handleRightMenu = event => {
    this.setState({ rightMenuOpen: true, anchorEl: event.currentTarget })
  }
  handleCloseDayClick = e => {
    this.props.showModal(MODAL_CLIENT_END_DAY)
  }
  handleCloseRightMenu = () => {
    this.setState({ rightMenuOpen: false, anchorEl: null })
  }
  handleToggleChat = e => {
    this.props.changeChat(!this.props.settings.chatEnabled)
  }
  render() {
    const { classes, theme, currentUser, currentPricing, settings } = this.props
    const { chatEnabled } = settings
    const { anchorEl, rightMenuOpen } = this.state
    const version = __TAG_VERSION__
    const iconColor = 'primary'
    const title = this.titleFromLocation(
      this.props.location.pathname,
      this.props.transactions
    )
    const initials =
      currentUser && currentUser.user_first_name && currentUser.user_last_name
        ? `${currentUser.user_first_name[0]}${currentUser.user_last_name[0]}`
        : ''
    const displayName =
      currentUser && currentUser !== null
        ? `${currentUser.user_first_name} ${currentUser.user_last_name}`
        : ''
    const avatarColor =
      currentUser && currentUser.color
        ? currentUser.color
        : theme.palette.secondary.main
    return (
      <AppBar className={classes.appBar} position="static">
        <Toolbar>
          <Avatar className={classes.logoAvatarSmall} src={Logo} />
          {this.shouldHaveBackButton(this.props.location.pathname) && (
            <IconButton
              onClick={this.handleBackButtonClick}
              className={classes.menuButton}
              color="inherit"
              aria-label="Retour">
              <NavigationLeft color="inherit" />
            </IconButton>
          )}
          <Typography variant="title" color="inherit" className={classes.flex}>
            {title}
          </Typography>
          {currentUser &&
            !currentUser.auth && (
              <AuthForm
                authHbUserDone={this.props.authHbUserDone}
                currentUser={currentUser}
              />
            )}
          {currentUser && (
            <TillForm
              hiboutikAccount={currentUser.hiboutikAccount}
              onRef={ref => (this.tillRef = ref)}
            />
          )}
          {currentUser && (
            <IconButton
              onClick={this.handleTillClick}
              className={classes.menuButton}
              color="inherit"
              aria-label="Ouvrir Tiroir">
              <TillIcon color="inherit" />
            </IconButton>
          )}
          {currentUser && (
            <IconButton
              onClick={this.handleChangeUserClick}
              className={classes.menuButton}
              color="inherit"
              aria-label="Changer d'utilisateur">
              <SwapCallsIcon color="inherit" />
            </IconButton>
          )}
          {currentUser && (
            <div>
              <IconButton
                aria-owns={rightMenuOpen ? 'menu-appbar' : null}
                aria-haspopup="true"
                onClick={this.handleRightMenu}
                color="inherit">
                <Avatar
                  className={classes.avatar}
                  style={{ backgroundColor: avatarColor }}>
                  {initials}
                </Avatar>
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                getContentAnchorEl={null}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right'
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right'
                }}
                open={rightMenuOpen}
                onClose={this.handleCloseRightMenu}>
                <MenuItem className={classes.menuItem} disabled>
                  <ListItemIcon className={classes.icon}>
                    <AccountCircle />
                  </ListItemIcon>
                  <ListItemText
                    classes={{ primary: classes.primary }}
                    inset
                    primary={displayName}
                  />
                </MenuItem>
                <MenuItem className={classes.menuItem} disabled>
                  <ListItemIcon className={classes.icon}>
                    <VersionIcon />
                  </ListItemIcon>
                  <ListItemText
                    classes={{ primary: classes.primary }}
                    inset
                    primary={`Version ${version}`}
                  />
                </MenuItem>
                <Divider />
                {currentPricing && (
                  <MenuItem className={classes.menuItem} disabled>
                    <ListItemIcon className={classes.icon}>
                      <PricingIcon />
                    </ListItemIcon>
                    <ListItemText
                      classes={{ primary: classes.primary }}
                      inset
                      primary={currentPricing.name}
                    />
                  </MenuItem>
                )}
                {currentPricing && (
                  <MenuItem
                    onClick={this.handleChangePricingClick}
                    className={classes.menuItem}>
                    <ListItemIcon className={classes.icon}>
                      <UpdatePricingIcon color={iconColor} />
                    </ListItemIcon>
                    <ListItemText
                      classes={{ primary: classes.primary }}
                      inset
                      primary="Changer le tarif en cours"
                    />
                  </MenuItem>
                )}
                {currentPricing && <Divider />}
                <MenuItem
                  className={classes.menuItem}
                  onClick={this.handleToggleChat}>
                  <ListItemIcon className={classes.icon}>
                    {chatEnabled ? (
                      <ChatIconOn color={iconColor} />
                    ) : (
                      <ChatIconOff color={iconColor} />
                    )}
                  </ListItemIcon>
                  <ListItemText
                    classes={{ primary: classes.primary }}
                    primary="Chat"
                  />
                  <Switch
                    onChange={this.handleToggleChat}
                    checked={chatEnabled}
                  />
                </MenuItem>
                <MenuItem
                  onClick={this.handleCloseDayClick}
                  className={classes.menuItem}>
                  <ListItemIcon className={classes.icon}>
                    <FinishDayIcon color={iconColor} />
                  </ListItemIcon>
                  <ListItemText
                    classes={{ primary: classes.primary }}
                    inset
                    primary="Terminer la journée"
                  />
                </MenuItem>
                <MenuItem
                  onClick={this.handleAdminClick}
                  className={classes.menuItem}>
                  <ListItemIcon className={classes.icon}>
                    <AdminIcon color={iconColor} />
                  </ListItemIcon>
                  <ListItemText
                    classes={{ primary: classes.primary }}
                    inset
                    primary="Administration"
                  />
                </MenuItem>
              </Menu>
            </div>
          )}
        </Toolbar>
      </AppBar>
    )
  }
}
const mapActionCreators = {
  authHbUserDone,
  selectUser,
  showModal,
  changeChat,
  signOut
}
const mapStateToProps = state => {
  return {
    auth: state.auth,
    currentUser: state.users.currentUser,
    currentPricing: state.settings.currentPricing,
    pricings: state.pricings.list,
    settings: state.settings,
    transactions: state.transactions.list
  }
}

export default connect(mapStateToProps, mapActionCreators)(
  withRouter(withStyles(styles, { withTheme: true })(HeaderContainer))
)



// WEBPACK FOOTER //
// ./src/containers/HeaderContainer.js